// @flow
import Resource from 'speed-js-core/src/api/Resource';

export default class ServiceAccessCodeResource extends Resource {
    basePath: string = 'services/access_code/';

    objectPath: string = 'services/access_code/{ident}/';
}
